module.exports = __webpack_public_path__ + "static/media/belllease.6cc6277d.png";